import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const COMET_PIXEL_SRC =
  "https://m.inhouse.ai/script.js?uid=19c526-1125899910000000-b18b59-s&domains=www.inhouse.ai,platform.inhouse.ai";

function isCometPixelPath(pathname) {
  const path = pathname.replace(/\/+$/, "") || "/";
  return (
    path === "/signin" ||
    path === "/signup" ||
    path === "/try" ||
    path === "/lp" ||
    path.startsWith("/lp/")
  );
}

function findCometScript() {
  return document.querySelector('script[data-ctag="cmt"]');
}

function ensureCometPixel() {
  if (findCometScript()) return;

  const script = document.createElement("script");
  script.src = COMET_PIXEL_SRC;
  script.setAttribute("data-ctag", "cmt");
  script.addEventListener(
    "load",
    () => {
      if (!isCometPixelPath(window.location.pathname)) {
        window.cometPauseEvents?.();
      }
    },
    { once: true }
  );
  document.head.appendChild(script);
}

export default function CometPixel() {
  const { pathname } = useLocation();
  const active = isCometPixelPath(pathname);

  useEffect(() => {
    if (process.env.REACT_APP_FRONTEND_BASE_ENDPOINT !== "https://platform.inhouse.ai") {
      return;
    }

    if (!active) {
      window.cometPauseEvents?.();
      return;
    }

    ensureCometPixel();
    window.cometResumeEvents?.();

    return () => {
      window.cometPauseEvents?.();
    };
  }, [active]);

  return null;
}
